import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import { setPhoneCallDetails, sendClickToCallStart, setActivityInactiveFromModal } from './Redux/clickToCallActions'

import InputWithCustomFormat from './InputWithCustomFormat'
import { notificationDanger, notificationDangerCustomTime } from '../../utils/customToastify'
import { setModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { EMAIL, OUT_GOING_CALL } from '../../constants/activityTypes'
import { isTaskAssigned } from '../Task/Redux/taskActions'
import { confirmUserPermission } from '../Contacts/Contact/services/contactServices'

const ClickToCall = ({
  name,
  value,
  placeholder,
  type,
  format,
  onChange,
  size,
  setPhoneCallDetails,
  contactId,
  hidePhoneIcon,
  disabled,
  onCallEnd,
  label,
  setModal,
  customOnClick,
  customIcon,
  activityType,
  setGlobalModalOverBootstrapModal,
  className,
  sendClickToCallStart,
  setActivityInactiveFromModal,
  activityId,
  userId,
  makeCallOnTaskComplete,
  userDataRedux,
  clickToCallModal,
}) => {
  const [isModalToggle, setIsModalToggle] = useState(false)
  const [isCalling, setIsCalling] = useState(false)

  // Reset calling state when modal is closed
  useEffect(() => {
    if (!clickToCallModal && isCalling) {
      // Reset calling state when modal is closed
      setIsCalling(false)
    }
  }, [clickToCallModal, isCalling])

  const startCall = async () => {
    const hasAssignedTask = await isTaskAssigned(userId, contactId)
    if (hasAssignedTask.length && !makeCallOnTaskComplete) {
      return notificationDanger('This user already has task assigned for this contact!')
    }
    if (activityType === EMAIL) {
      if (!value) {
        return notificationDanger('Please Enter Email First')
      }

      // Do not open the OS mail client (Outlook, etc.) — emails are sent only through the CRM
      setIsModalToggle(!isModalToggle)
      setPhoneCallDetails(contactId, value)
      setModal({
        id: 'clickToCall',
        name: 'Edit Activity',
        props: {
          callback: onCallEnd,
          defaultActivityType: EMAIL,
          activityTypeDisabled: true,
          activityType: EMAIL,
        },
      })
    } else {
      if (!value) {
        return notificationDanger('Please Enter Phone Number First')
      }
      if (!userDataRedux.officeExt) {
        return notificationDangerCustomTime(
          'Please enter office extension inside your profile to be able to make a call!',
          10000
        )
      }
      if (!userDataRedux.activePhone) {
        return notificationDangerCustomTime(
          'Please enter active phone inside your profile to be able to make a call!',
          10000
        )
      }
      //  alert(value)
      if (activityType === OUT_GOING_CALL) {
        setIsCalling(true)
        let data = {
          activityType,
          contact_id: contactId,
          call_number: value,
        }
        try {
          await sendClickToCallStart(data)
        } catch (e) {
          setIsCalling(false)
          return
        }
      }

      setIsModalToggle(!isModalToggle)
      setPhoneCallDetails(contactId, value)
      !makeCallOnTaskComplete &&
        setModal({
          id: 'clickToCall',
          name: 'Edit Activity',
          setGlobalModalOverBootstrapModal,
          props: {
            startedCall: true,
            onCloseModalClick: () => {
              setIsCalling(false)
              setActivityInactiveFromModal()
            },
            activityId,
            callback: () => {
              setIsCalling(false)
              if (onCallEnd) {
                onCallEnd()
              }
            },
            defaultActivityType: OUT_GOING_CALL,
            activityTypeDisabled: true,
          },
        })
    }
  }

  const handleClick = async () => {
    // Prevent multiple clicks while call is in progress
    if (isCalling) {
      return
    }

    let hasPermission = false
    const response = await confirmUserPermission(contactId, userDataRedux)
    if (response.status !== 200) {
      hasPermission = false
    } else {
      hasPermission = response?.data?.hasPermission
    }

    if (hasPermission) {
      if (makeCallOnTaskComplete) {
        if (customOnClick) {
          customOnClick()
        }
        await startCall()
      } else {
        if (customOnClick) {
          customOnClick()
        } else {
          await startCall()
        }
      }
    } else {
      notificationDangerCustomTime(`You're not allowed to call this contact`)
    }
  }

  return (
    <>
      <InputWithCustomFormat
        className={className + ' w-100'}
        name={name}
        value={value}
        placeholder={placeholder}
        type={type}
        format={format}
        onChange={onChange}
        disabled={disabled}
        size={size}
        customIcon={customIcon}
        onClickFunction={isCalling ? null : handleClick}
        hidePhoneIcon={hidePhoneIcon || isCalling}
        label={label}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    activityId: state.ClickToCall.activityId,
    userId: state.auth.user.userId,
    userDataRedux: state.auth.user,
    clickToCallModal: state.GlobalModal?.modals?.clickToCall,
  }
}

export default connect(mapStateToProps, {
  setPhoneCallDetails,
  setModal,
  sendClickToCallStart,
  setActivityInactiveFromModal,
})(ClickToCall)
